const state = {
  report: [],
  report_id: [],
  reason: [],
  rejectReason: [],
  adminHub: [],
};

export default state;
